import { redirect } from '@tanstack/react-router'
import { useAuthStore, AUTH_DISABLED } from '@/stores/auth'

/**
 * guards.ts — substitui `src/middleware.ts` da versão Next.js.
 *
 * O middleware rodava no Edge e só conseguia checar a *existência* do cookie
 * `laravel_session` (httpOnly). Aqui o guard roda no browser e faz a validação
 * de verdade: chama `/api/auth/me` uma única vez e guarda o resultado no store.
 * Na prática é uma checagem mais forte do que a anterior, não mais fraca — a
 * validação real sempre foi do Laravel.
 */

/** Garante que a sessão já foi resolvida (`authed` ou `guest`). */
async function resolveSession() {
  const { status, fetchSession } = useAuthStore.getState()
  if (status === 'idle' || status === 'loading') {
    await fetchSession()
  }
  return useAuthStore.getState().status
}

/**
 * Bloqueia rotas do dashboard sem sessão, preservando a URL original em
 * `callbackUrl` para o redirect pós-login (mesmo comportamento do middleware).
 */
export async function requireAuth({ location }: { location: { href: string } }) {
  if (AUTH_DISABLED) return

  const status = await resolveSession()

  if (status !== 'authed') {
    throw redirect({
      to: '/login',
      search: { callbackUrl: location.href },
    })
  }
}

/**
 * O inverso, para as rotas públicas de autenticação: quem já está logado não
 * deve ver a tela de login.
 */
export async function redirectIfAuthed() {
  if (AUTH_DISABLED) return

  const status = await resolveSession()

  if (status === 'authed') {
    throw redirect({ to: '/dashboard' })
  }
}
